module.exports = __webpack_public_path__ + "img/page5.dbae2bf8.jpg";